import BookWithPartnerModal from './BookWithPartnerModal';

export default BookWithPartnerModal;
